import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import PortalPage from './pages/PortalPage'
import TrashPage from './pages/TrashPage'
import SettingsPage from './pages/SettingsPage'
import SharePage from './pages/SharePage'
import AdminPage from './pages/AdminPage'
import NotFoundPage from './pages/NotFoundPage'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import { useAuth } from './hooks/useAuth'

function App() {
  const { loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[var(--color-primary)]"></div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/login" replace />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="portal" element={
          <ProtectedRoute>
            <Navigate to="/portal/files" replace />
          </ProtectedRoute>
        } />
        <Route path="portal/files" element={
          <ProtectedRoute>
            <PortalPage activeTab="files" />
          </ProtectedRoute>
        } />
        <Route path="portal/trash" element={
          <ProtectedRoute>
            <TrashPage />
          </ProtectedRoute>
        } />
        <Route path="portal/shared" element={
          <ProtectedRoute>
            <PortalPage activeTab="shared" />
          </ProtectedRoute>
        } />
        <Route path="portal/settings" element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } />
        <Route path="portal/admin" element={
          <AdminRoute>
            <AdminPage />
          </AdminRoute>
        } />
        <Route path=":hash" element={<SharePage />} />
        <Route path="404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Route>
    </Routes>
  )
}

export default App